import { render, staticRenderFns } from "./horizontalMenu.vue?vue&type=template&id=6c106a78&scoped=true"
import script from "./horizontalMenu.vue?vue&type=script&lang=js"
export * from "./horizontalMenu.vue?vue&type=script&lang=js"
import style0 from "./horizontalMenu.vue?vue&type=style&index=0&id=6c106a78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c106a78",
  null
  
)

export default component.exports